import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Spline from "@splinetool/react-spline";
import "./loginRegister.css";
import Loading1 from "../loading_animation/loading";

const LoginRegister = ({ setLoginTrigger }) => {
  const [isSignIn, setIsSignIn] = useState(false);
  const [loginEmail, setLoginEmail] = useState("");
  const [registerEmail, setRegisterEmail] = useState("");
  const [registerMobile, setRegisterMobile] = useState("");
  const [password, setPassword] = useState("");
  const [showValidation, setShowValidation] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });
  const navigate = useNavigate();
  const [passwordValidations, setPasswordValidations] = useState({
    length: false,
    uppercase: false,
    number: false,
    special: false,
  });
  const [countryCodes, setCountryCodes] = useState([]);
  const [countryCode, setCountryCode] = useState("+91");
  const [isOtpVerified, setIsOtpVerified] = useState({
    login: false,
    register: false
  });

    const [isLoading, setIsLoading] = useState({
    login: false,
    register: false,
    sendOtp: {
      login: false,
      register: false
    },
    verifyOtp: {
      login: false,
      register: false
    }
  });

  const [config, setConfig] = useState(null);
  const [otpTimer, setOtpTimer] = useState({
  login: 0,
  register: 0
});
const [canResend, setCanResend] = useState({
  login: true,
  register: true
});


  const LoadingButton = ({ 
    children, 
    loading, 
    disabled, 
    type = "button", 
    onClick, 
    className = "" 
  }) => (
    <button
      type={type}
      className={`${className} ${loading ? 'loading' : ''}`}
      disabled={disabled || loading}
      onClick={onClick}
    >
      {loading ? <Loading1 size="small" /> : children}
    </button>
  );

  // OTP related states
  const [otpSent, setOtpSent] = useState({
    login: false,
    register: false
  });
  const [loginOtp, setLoginOtp] = useState("");
  const [registerOtp, setRegisterOtp] = useState("");
  const [otpMessage, setOtpMessage] = useState({
    text: "",
    type: "" 
  });
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordMatchError, setPasswordMatchError] = useState(false);

  useEffect(() => {
    fetch("/countrycodes.json")
      .then((res) => res.json())
      .then((data) => setCountryCodes(data))
      .catch((err) => console.error("Error loading country codes:", err));

    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch((err) => console.error("Error loading config:", err));
  }, []);

  useEffect(() => {
    if (otpMessage.text) {
      const timer = setTimeout(() => {
        setOtpMessage({ text: "", type: "" });
      }, 5000); 

      return () => clearTimeout(timer); 
    }
  }, [otpMessage]);

  const toggleSignIn = (e) => {
    e.stopPropagation();
    setIsSignIn(!isSignIn);
    setIsOtpVerified({
      login: false,
      register: false
    });
  };

  const startOtpTimer = (type, duration = 55) => {
  setCanResend(prev => ({ ...prev, [type]: false }));
  setOtpTimer(prev => ({ ...prev, [type]: duration }));

  const timerId = setInterval(() => {
    setOtpTimer(prev => {
      const newVal = { ...prev, [type]: prev[type] - 1 };
      if (newVal[type] <= 0) {
        clearInterval(timerId);
        setCanResend(p => ({ ...p, [type]: true }));
      }
      return newVal;
    });
  }, 1000);
};


  const handleLoginSubmit = async (e) => {
    e.preventDefault();

    // Check if OTP is verified
    if (!isOtpVerified.login) {
      setOtpMessage({ text: "Please verify your email with OTP first", type: "error" });
      return;
    }
    setIsLoading({ ...isLoading, login: true });

    try {
      const response = await fetch(`${config.BASE_URL}${config.USER_LOGIN}`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: loginEmail,
          password: password,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setOtpMessage({ text: "Login successful", type: "success" });
        if (data.token) {
          localStorage.setItem("authToken", data.token);
        }
        setLoginTrigger(prev => prev + 1);
        navigate("/account");
      } else {
        setOtpMessage({
          text: data.message || "Invalid credentials",
          type: "error",
        });
      }
    } catch (err) {
      setMessage({ text: "Network error. Please try again.", type: "error" });
    }
    finally {
      setIsLoading({ ...isLoading, login: false });
    }
  };

  const handleRegisterSubmit = async (e) => {
    e.preventDefault();

    // Check if OTP is verified
    if (!isOtpVerified.register) {
      setOtpMessage({ text: "Please verify your email with OTP first", type: "error" });
      return;
    }

    if (password !== confirmPassword) {
      setPasswordMatchError(true);
      setOtpMessage({ text: "Passwords do not match", type: "error" });
      return;
    } else {
      setPasswordMatchError(false);
    }
    
    setIsLoading({ ...isLoading, register: true });

    const fullname = document.getElementById("signInName").value;
    const mobileNumber = registerMobile;
    const mail = registerEmail;
    const passwordValue = password;

    try {
      const response = await fetch(`${config.BASE_URL}${config.USER_SIGNUP}`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          fullname,
          email: mail,
          password: passwordValue,
          mobile: mobileNumber,
          email_verified: 1,
        }),
      });

      const data = await response.json();
      if (data.success) {
        setOtpMessage({ text: data.message, type: "success" });
        // Reset form and OTP status
        setRegisterEmail("");
        setRegisterMobile("");
        setPassword("");
        setRegisterOtp("");
        setConfirmPassword("");
        setIsOtpVerified({...isOtpVerified, register: false});
        setIsSignIn(true);
      } else {
        setOtpMessage({ text: data.message, type: "error" });
      }
    } catch (err) {
      setOtpMessage({ text: "Registration failed.", type: "error" });
    }
    finally {
      setIsLoading({ ...isLoading, register: false });
    }
  };

  const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);

  const handleSendOtp = async (type) => {
    try {
      const email = type === "login" ? loginEmail : registerEmail;
      const fullName = type === "login" ? "User" : document.getElementById("signInName").value;
      
      if (!isValidEmail(email)) {
        setOtpMessage({ text: "Please enter a valid email address", type: "error" });
        return;
      }

        setIsLoading({
        ...isLoading, 
        sendOtp: { ...isLoading.sendOtp, [type]: true }
      });

      // Use different endpoints for login and registration
      const endpoint = type === "login" 
        ? config.EMAIL_LOGIN_OTP
        : config.EMAIL_SIGNUP_OTP;

      const response = await fetch(`${config.BASE_URL}${endpoint}`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          email, 
          name: fullName,
          type 
        }),
      });

      const data = await response.json();
      if (data.success) {
        const otpData = {
          otp: data.otp,
          expiresAt: Date.now() + 300000 
        };
        localStorage.setItem(`otp_${type}`, JSON.stringify(otpData));
        
        setOtpSent({ ...otpSent, [type]: true });
        setIsOtpVerified({...isOtpVerified, [type]: false});
        setOtpMessage({ 
          text: "OTP sent successfully! Check your email.", 
          type: "success"   
        });
        startOtpTimer(type, 55);
      } else {
        setOtpMessage({ 
          text: data.message || "Failed to send OTP.", 
          type: "error" 
        });
      }
    } catch (error) {
      setOtpMessage({ 
        text: "Error sending OTP.", 
        type: "error" 
      });
      console.error("OTP Error:", error);
    }finally {
      // Reset loading state
      setIsLoading({
        ...isLoading, 
        sendOtp: { ...isLoading.sendOtp, [type]: false }
      });
    }
  };

  const handleVerifyOtp = (type, enteredOtp) => {
    const storedOtp = JSON.parse(localStorage.getItem(`otp_${type}`));
    
    if (!storedOtp) {
      setOtpMessage({ text: "OTP expired. Please request a new one.", type: "error" });
      return;
    }

    if (Date.now() > storedOtp.expiresAt) {
      setOtpMessage({ text: "OTP expired. Please request a new one.", type: "error" });
      localStorage.removeItem(`otp_${type}`);
      return;
    }
    
    if (enteredOtp.toString() === storedOtp.otp.toString()) { 
      setOtpMessage({ text: "OTP verified successfully!", type: "success" });
      localStorage.removeItem(`otp_${type}`); 
      setOtpSent({ ...otpSent, [type]: false }); 
      if(type === "login") setLoginOtp("");
      else setRegisterOtp("");
      setIsOtpVerified({...isOtpVerified, [type]: true});
    } else {
      setOtpMessage({ text: "Invalid OTP. Please try again.", type: "error" });
    }
  };

  useEffect(() => {
    setShowValidation(password.length > 0);
    setPasswordValidations({
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      number: /[0-9]/.test(password),
      special: /[!@#$%^&*]/.test(password),
    });
  }, [password]);

 return (
  <div className="login-page-cont">
    {(isLoading.login || isLoading.register || isLoading.sendOtp.login || isLoading.sendOtp.register || isLoading.verifyOtp.login || isLoading.verifyOtp.register) && (
  <div className="loading-popup">
    <Loading1 size="large" />
  </div>
)}
    {/* Bubble Background */}
    <div className="bubble-container">
      {Array.from({ length: 10 }).map((_, i) => (
        <span key={i} className="bubble"></span>
      ))}
    </div>

    <div className="login-split-container">
      {/* LEFT SIDE: Spline + Toggle Button */}
      <div className="left-side-container">
        <div className="login-gif-container">
          <Spline
            scene="https://prod.spline.design/56dQZT9gBxyHW8Le/scene.splinecode"
            className="login-spline"
          />
        </div>

        <button
          type="button"
          className="btn signin-btn"
          onClick={toggleSignIn}
        >
          <span id="login">{isSignIn ? "Login" : "Sign Up"}</span>
          <i className="fas fa-hand-point-right"></i>
        </button>
      </div>

      {/* RIGHT SIDE: Forms */}
      <div className={`forms-cont ${isSignIn ? "signin" : ""}`}>
        <div className="form-flip-container">
          {/* LOGIN FORM */}
          <div className="login-form">
            <form className="form-inputs" onSubmit={handleLoginSubmit}>
              <h2 className="form-heading">Login</h2> 
              <div className="form-group email-with-otp">
                <label className="input-label" htmlFor="inputEmail">
                  <i className="fas fa-user"></i> Email
                </label>
                <div className="email-input-group">
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    id="inputEmail"
                    placeholder="example@gmail.com"
                    value={loginEmail}
                    onChange={(e) => setLoginEmail(e.target.value)}
                    required
                  />
                  <button
                type="button"
                className="send-otp-btn"
                onClick={() => handleSendOtp("login")}
                disabled={!isValidEmail(loginEmail) || !canResend.login}
              >
                {canResend.login ? "Send OTP" : `Resend in ${otpTimer.login}s`}
              </button>

                </div>
              </div>

              {otpSent.login && (
                <div className="form-group email-with-otp">
                  <label className="input-label" htmlFor="loginOtp">
                    <i className="fas fa-shield-alt"></i> Enter OTP
                  </label>
                  <div className="email-input-group">
                    <input
                      type="text"
                      className="form-control"
                      name="otp"
                      id="loginOtp"
                      placeholder="Enter 6-digit OTP"
                      value={loginOtp}
                     onChange={(e) => {
                        const value = e.target.value;
                        setLoginOtp(value);
                        if (value.length === 6) {
                          handleVerifyOtp("login", value);
                        }
                      }}
                      maxLength={6}
                      required
                    />
                    {/* <button
                      type="button"
                      className="send-otp-btn"
                      onClick={() => handleVerifyOtp("login", loginOtp)}
                    >
                      Verify OTP
                    </button> */}
                  </div>
                </div>
              )}

              <div className="form-group">
                <label className="input-label" htmlFor="inputPassword">
                  <i className="fas fa-key"></i> Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  name="password"
                  id="inputPassword"
                  placeholder="example@123"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              {otpMessage.text && (
                <div className={`otp-message ${otpMessage.type}`}>
                  <i className={`fas ${
                    otpMessage.type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'
                  }`}></i>
                  <span>{otpMessage.text}</span>
                </div>
              )}

              <button 
                type="submit" 
                className="btn btn-block"
                disabled={!isOtpVerified.login}
              >
                {isOtpVerified.login ? "Login" : "Verify Email First"}
              </button>
            </form>
          </div>

          {/* REGISTER FORM */}
          <div className="register-form">
            <form className="form-inputs" onSubmit={handleRegisterSubmit}>
              <h2 className="form-heading">Sign Up</h2>

              <div className="form-group">
                <label className="input-label" htmlFor="signInName">
                  <i className="fas fa-user"></i> Full Name*
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  id="signInName"
                  placeholder="Enter name"
                  required
                />
              </div>

              <div className="form-group email-with-otp">
                <label className="input-label" htmlFor="signInEmail">
                  <i className="fas fa-envelope"></i> Email*
                </label>
                <div className="email-input-group">
                  <input
                    type="email"
                    className="form-control"
                    name="signEmail"
                    id="signInEmail"
                    placeholder="example@gmail.com"
                    value={registerEmail}
                    onChange={(e) => setRegisterEmail(e.target.value)}
                    required
                  />
                  <button
                  type="button"
                  className="send-otp-btn"
                  onClick={() => handleSendOtp("register")}
                  disabled={!isValidEmail(registerEmail) || !canResend.register}
                >
                  {canResend.register ? "Send OTP" : `Resend in ${otpTimer.register}s`}
                </button>

                </div>
              </div>

              {otpSent.register && (
                <div className="form-group email-with-otp">
                  <label className="input-label" htmlFor="registerOtp">
                    <i className="fas fa-shield-alt"></i> Enter OTP
                  </label>
                  <div className="email-input-group">
                    <input
                      type="text"
                      className="form-control"
                      name="otp"
                      id="registerOtp"
                      placeholder="Enter 6-digit OTP"
                      value={registerOtp}
                      onChange={(e) => {
                        const value = e.target.value;
                        setRegisterOtp(value);
                        if (value.length === 6) {
                          handleVerifyOtp("register", value);
                        }
                      }}
                      maxLength={6}
                      required
                    />
                    {/* <button
                      type="button"
                      className="send-otp-btn"
                      onClick={() => handleVerifyOtp("register", registerOtp)}
                    >
                      Verify OTP
                    </button> */}
                  </div>
                </div>
              )}

              {otpMessage.text && (
                <div className={`otp-message ${otpMessage.type}`}>
                  <i className={`fas ${
                    otpMessage.type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'
                  }`}></i>
                  <span>{otpMessage.text}</span>
                </div>
              )}

              <div className="form-group">
                <label className="input-label" htmlFor="signInMobile">
                  <i className="fas fa-phone"></i> Mobile Number*
                </label>
                <div className="mobile-input-group">
                  <select
                    className="country-code-dropdown"
                    value={countryCode}
                    onChange={(e) => setCountryCode(e.target.value)}
                  >
                    {countryCodes.map(c => (
                      <option key={`${c.code}-${c.dial_code}`} value={c.dial_code}>
                       {c.dial_code} {c.name} 
                      </option>
                    ))}
                  </select>
                  <input
                    type="tel"
                    className="form-control mobile-input"
                    name="mobile"
                    id="signInMobile"
                    placeholder="Enter mobile number"
                    value={registerMobile}
                    onChange={(e) => setRegisterMobile(e.target.value)}
                    pattern="[0-9]{10}"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="input-label" htmlFor="crtePassword">
                  <i className="fas fa-key"></i> Create Password*
                </label>
                <input
                  type="password"
                  className="form-control"
                  name="crtePass"
                  id="crtePassword"
                  placeholder="example@123"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              {showValidation && (
                <ul className="validation-list">
                  <li className={passwordValidations.length ? "valid" : "invalid"}>
                    Min 8 characters
                  </li>
                  <li className={passwordValidations.uppercase ? "valid" : "invalid"}>
                    1 uppercase letter
                  </li>
                  <li className={passwordValidations.number ? "valid" : "invalid"}>
                    1 number
                  </li>
                  <li className={passwordValidations.special ? "valid" : "invalid"}>
                    1 special character
                  </li>
                </ul>
              )}

              <div className="form-group">
                <label className="input-label" htmlFor="confirmPassword">
                  <i className="fas fa-check-double"></i> Confirm Password*
                </label>
                <input
                  type="password"
                  className={`form-control ${passwordMatchError ? 'is-invalid' : ''}`}
                  name="confirmPassword"
                  id="confirmPassword"
                  placeholder="example@123"
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    setPasswordMatchError(password !== e.target.value);
                  }}
                  required
                />
                {passwordMatchError && (
                  <div className="invalid-feedback">Passwords do not match</div>
                )}
              </div>

              <button 
                type="submit" 
                className="btn btn-block"
                disabled={!isOtpVerified.register}
              >
                {isOtpVerified.register ? "Register" : "Verify Email First"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
);

};

export default LoginRegister;